export class InvoiceDetail {
  invoiceId = 0;
  invoiceNo = "";
  referenceType = "";
  referenceName = "";
  billedToName = "";
  billedToPhone = "";
  createdAt = "";
  totalStt = 0;
  totalTariff = 0;
  totalAmount = 0;
  totalPaid = 0;
  balanceDue = 0;
  status = "";
  note = "";
  billedToSend = [];

  constructor(fields?: Partial<InvoiceDetail>) {
    Object.assign(this, fields);
  }
}

export class InvoiceDataInterface {
  id = 0;
  invoiceNo = "";

  constructor(fields?: Partial<InvoiceDataInterface>) {
    Object.assign(this, fields);
  }
}

export class SttInvoice {
  no = 0;
  sttNo = "";
  shipmentId = "";
  isCod = false;
  isDfod = false;
  isCashless = false;
  createdAt = "";
  recipientName = "";
  recipientPhoneMasked = "";
  productType = "";
  chargeableWeight = 0;
  tariff = 0;
  amount = 0;
  paymentLabel = "";

  constructor(fields?: Partial<SttInvoice>) {
    Object.assign(this, fields);
  }
}

export class SendInvoiceRequestSendTo {
  via = "";
  phone = "";
  email = "";
  format = "";
  formatDisplay = "";

  constructor(fields?: Partial<SendInvoiceRequestSendTo>) {
    Object.assign(this, fields);
  }
}

export class SendInvoiceResponseSendTo {
  no = 0;
  via = "";
  phone = "";
  email = "";
  format = "";
  formatDisplay = "";

  constructor(fields?: Partial<SendInvoiceRequestSendTo>) {
    Object.assign(this, fields);
  }
}

export class SendInvoiceRequest {
  sendTo = [] as SendInvoiceRequestSendTo[];
  filePdfA4 = [];
  filePngA4 = [];
  filePdfStruk = [];

  constructor(fields?: Partial<SendInvoiceRequest>) {
    Object.assign(this, fields);
  }
}

export class SendInvoiceResponseData {
  invoiceId = 0;
  invoiceNo = "";
  sentCount = 0;
  deliveries = [] as SendInvoiceResponseSendTo[];

  constructor(fields?: Partial<SendInvoiceResponseData>) {
    Object.assign(this, fields);
  }
}
import { Pagination } from "./Pagination";

export class ListInvoiceItem {
  id = 0;
  invoiceNo = "";
  billedToName = "";
  billedToPhone = "";
  totalAmount = 0;
  totalPaid = 0;
  status = "";
  isInvoicePrinted = false;
  isInvoiceSent = false;
  createdAt = "";
  createdByName = "";
  updatedAt = "";
  updatedByName = "";

  constructor(fields?: Partial<ListInvoiceItem>) {
    Object.assign(this, fields);
  }
}

export class PrintReceiptListInvoice {
  data: ListInvoiceItem[] = [];
  pagination: Pagination = new Pagination(1, 10, 0);
  constructor(fields?: PrintReceiptListInvoice) {
    Object.assign(this, fields);
  }
}
export class PaymentHistory {
  date = "";
  amount = 0;
  user = "";

  constructor(fields?: Partial<PaymentHistory>) {
    Object.assign(this, fields);
  }
}

export class Invoice {
  header = new InvoiceDetail();
  items: SttInvoice[] = [];

  constructor(fields?: Partial<Invoice>) {
    Object.assign(this, fields);

    if (fields?.header) {
      this.header = new InvoiceDetail(fields.header);
    }

    if (fields?.items) {
      this.items = fields.items.map((item) => new SttInvoice(item));
    }
  }
}

export class SttHistorySuccessBooking {
  sttId = 0;
  sttNo = "";
  senderName = "";
  senderPhone = "";
  productType = "";
  chargeableWeight = 0;
  amount = 0;
  tariff = 0;
  isCod = false;
  isDfod = false;
  isCashless = false;
  printReceiptFlag = false;
  createInvoiceFlag = false;
  selected = false;

  constructor(fields?: Partial<SttHistorySuccessBooking>) {
    Object.assign(this, fields);
  }
}

export class InvoiceData {
  id = 0;
  invoiceNumber = "";
  status: "UNPAID" | "PARTIAL" | "PAID" = "UNPAID";
  customerName = "";
  customerPhone = "";
  totalStt = 0;
  totalAmount = 0;
  paymentHistory: PaymentHistory[] = [];
  totalPaid = 0;
  balanceDue = 0;

  constructor(fields?: Partial<InvoiceData>) {
    Object.assign(this, fields);
  }
}

export const PRINT_RECEIPT_KEY = {
  LIST_STT_SUCCESS_BOOKING: "list-stt-success-booking",
  LAST_DATE_STT_SUCCESS_BOOKING: "last-date-stt-success-booking",
  PRINT_RECEIPT_CHANNEL: "print-receipt-channel"
};

export class SuccessInvoiceData {
  invoiceId = 0;
  invoiceNo = "";
  bookedBy = "";
  bookedByPhone = "";
  totalStt = 0;
  totalAmount = 0;
  balanceDue = 0;

  constructor(fields?: Partial<SuccessInvoiceData>) {
    Object.assign(this, fields);
  }
}

export interface Receiver {
  via: string;
  viaExpanded: boolean;
  value: string;
  format: string;
  formatExpanded: boolean;
  error: boolean;
  errorMessage: string;
  errorFormat: boolean;
  errorFormatMessage: string;
}

export type PrintReceiptMessage =
  | {
      type: "SYNC_LIST";
      payload: string[];
    }
  | {
      type: "SYNC_LAST_DATE";
      payload: string;
    };

class PrintReceiptChannelService {
  private channel: BroadcastChannel;

  constructor() {
    this.channel = new BroadcastChannel(
      PRINT_RECEIPT_KEY.PRINT_RECEIPT_CHANNEL
    );
  }

  post(message: PrintReceiptMessage) {
    this.channel.postMessage(message);
  }

  onMessage(callback: (message: PrintReceiptMessage) => void) {
    this.channel.onmessage = (event) => {
      callback(event.data);
    };
  }
}

export class SttInvoiceForUpdate extends SttInvoice {
  senderName = "";
  senderPhone = "";
  destinationCity = "";

  constructor(fields?: Partial<SttInvoiceForUpdate>) {
    super();
    Object.assign(this, fields);
  }
}

export class InvoiceForUpdate {
  header = new InvoiceDetail();
  items: SttInvoiceForUpdate[] = [];

  constructor(fields?: Partial<InvoiceForUpdate>) {
    Object.assign(this, fields);
  }
}

export const printReceiptChannel = new PrintReceiptChannelService();

export class RecipientTag {
  type = "";
  contact = "";
  format = "";

  constructor(fields?: Partial<RecipientTag>) {
    Object.assign(this, fields);
  }
}

export class AddDraftResponseData {
  totalStt = 5;
  totalSenders = 3;

  constructor(fields?: Partial<AddDraftResponseData>) {
    Object.assign(this, fields);
  }
}

export class GetPreviewResponseData {
  data: GetPreviewData[] = [];

  constructor(fields?: Partial<GetPreviewResponseData>) {
    Object.assign(this, fields);
  }
}

export class GetPreviewData {
  id = 0;
  tariff = 0;
  sttNo = "";
  shipmentId = "";
  isCod = false;
  isDfod = false;
  isCashless = false;
  createdAt = "";
  recipientName = "";
  recipientPhoneMasked = "";
  destination3lc = "";
  destinationName = "";
  productType = "";
  chargeableWeight = 0;
  amount = 0;
  paymentLabel = "";
  senderName = "";
  senderPhone = "";

  constructor(fields?: Partial<GetPreviewData>) {
    Object.assign(this, fields);
  }
}

export class SuccessUpdateReceipt extends InvoiceDetail {
  updatedAt = "";

  constructor(fields?: Partial<SuccessUpdateReceipt>) {
    super();
    Object.assign(this, fields);
  }
}
